import React, { Component } from 'react';
import {
    List,
    EmailField,
    TextField,
    DateField,
    Pagination,
    Datagrid,
    ReferenceField,
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    Filter,
    SearchInput,
} from 'react-admin';
import {HEXSelectorField, BasicButton} from './UserListComponents';
import { Button } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import { API_BASE_URL } from '../config.jsx';
// import { Link } from 'react-router-dom';
// import { linkToRecord } from 'ra-core';
import { usePermissions } from 'react-admin';
import { ROLE_ADMIN, isInRole } from '../authProvider';


class NotifyLLMButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: props.record.id,
            fetching: false,
            hasSent: false,
            failed: false,
        };
    }
    NotifyLLM = (id) => {
        console.log(id);
        const token = localStorage.getItem('token');
        this.setState({ fetching: true, hasSent: false });
        fetch(`${API_BASE_URL}/HEXSelector/Account/NotifyLLM?userId=${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(r => {
            if (!r.ok) {
                throw Error(r.statusText);
            }
            this.setState({ fetching: false, hasSent: true });
        }).catch(err => {
            console.log(err);
            this.setState({ fetching: false, hasSent: false, failed: true })
        });

    }
    render() {
        return (
            <Button
                disabled={this.state.fetching}
                onClick={() => this.NotifyLLM(this.state.userId)}
            >
                <EmailIcon />{this.state.hasSent ? <CheckIcon /> : ''}{this.state.failed ? <CloseIcon /> : ''}
            </Button>
        )
    }
}

class NotifyLLMField extends Component {
    render() {
        return (
            <ReferenceField {...this.props} label='HEXSelector' sortable={false} source="id" link={false} reference="HEXSelector/Users" allowEmpty={false}>
                <NotifyLLMButton userId={this.props.record.id} linkToRecord={this.props.reference} />
            </ReferenceField>)
    }
}

const PendingFilter = (props) => {
    return (
        <Filter {...props}>
            <SearchInput source="q" alwaysOn />

        </Filter>
    );
}

export const HEXSelectorPendingRequestsList = (props) => {
    const {permissions} = usePermissions();
    const isAdmin = isInRole(ROLE_ADMIN, permissions);
    return (
        <List title="Pending Requests" {...props} sort={{ field: 'requestDate', order: 'DESC' }} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />} filters={<PendingFilter />}>
        <Datagrid>
            <DateField source="requestDate" showTime={true} sortable={true} />
            <EmailField source="email" sortable={true} />
            {/* <TextField source="title" /> */}
            <TextField source="givenName" sortable={true} />
            <TextField source="surname" sortable={true} />
            <TextField source="segment" sortable={true} />
            <TextField source="company" sortable={true} />
            <TextField source="country" sortable={true} />
            <TextField source="city" sortable={true} />
            <TextField source="contact" sortable={false} />
            {isAdmin ?
            <ReferenceArrayField label="LLM" source="llm_ids" reference="HEXSelector/LocalLicenseManagers" perPage={1000}>
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>                        
            </ReferenceArrayField>
            : null}
            <HEXSelectorField label='HEXSelector Profile' />
            <BasicButton label='User Profile' />
          {isAdmin ? <NotifyLLMField label="Notify LLM" /> : null }
        </Datagrid>
    </List>);
}
